import { FC, memo } from 'react'
import type { Props } from '../../types'

const GreyStar: FC<Props> = ({ size = 16, ...rest }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.21975 7.38763L11.8082 5.15116C12.1743 4.83355 11.9849 4.21157 11.5051 4.18511L8.17175 3.97337C7.96973 3.96014 7.79296 3.8278 7.7172 3.6293L6.49243 0.347381C6.31566 -0.115794 5.69697 -0.115794 5.52019 0.347381L4.29543 3.61607C4.21967 3.81457 4.0429 3.9469 3.84088 3.96014L0.494864 4.17187C0.0150585 4.19834 -0.174338 4.82032 0.191829 5.13792L2.78025 7.36116C2.93177 7.49349 3.00753 7.71846 2.95702 7.91697L2.11105 11.318C1.99741 11.7944 2.48984 12.1782 2.89389 11.9135L5.70959 10.0211C5.88636 9.902 6.10101 9.902 6.26516 10.0211L9.09348 11.9135C9.49753 12.1782 9.98996 11.7944 9.87632 11.318L9.03035 7.9302C8.99247 7.7317 9.0556 7.51996 9.21975 7.38763Z"
        fill="#7E8C9C"
      />
    </svg>
  )
}

export default memo(GreyStar)
